import { useState } from 'react';
import { Eye, EyeOff } from 'lucide-react'; // o cualquier librería de íconos

function PasswordInput({ formData, handleChange,name = 'password',tittle ,placeholder = 'Ingresa tu contraseña'},id) {
  const [showPassword, setShowPassword] = useState(false);

  console.log('PasswordInput props:', { name, value: formData?.[name] });

  return (
    <div className="input-field">
      <label htmlFor="password">{tittle}</label>
      <div className="password-wrapper" style={{ position: 'relative' }}>
        <input
          id={id || name}
          type={showPassword ? 'text' : 'password'}
          name={name}
          value={formData[name] || ''}
          onChange={handleChange}
          placeholder={placeholder}
          autoComplete={name === 'newPassword' ? 'new-password' : 
                     name === 'confirmPassword' ? 'new-password' : 'current-password'}
          style={{ paddingRight: '40px' , width: '100%',boxSizing: 'border-box'}}
        />
        <button
          type="button"
          onClick={() => setShowPassword(!showPassword)}
          onMouseEnter={(e) => e.target.style.color = '#333'}
          onMouseLeave={(e) => e.target.style.color = '#666'}
          style={{
            position: 'absolute',
            right: '10px',
            top: '50%',
            transform: 'translateY(-50%)',
            background: 'none',
            border: 'none',
            cursor: 'pointer',
            padding: '5px',
            color: '#666',
            transition: 'color 0.2s'
          }}
          aria-label={showPassword ? 'Ocultar contraseña' : 'Mostrar contraseña'}
        >
          {showPassword ? <EyeOff size={20} /> : <Eye size={20} />}
        </button>
      </div>
    </div>
  );
}

export default PasswordInput;